'use strict';

(function ($) {

  // on load get the unique values from the list of images
  var galleryCategories = [];

  $('.gallery__container').each(function () {
    if (galleryCategories.includes($(this).data('gallery-category')) === false && $(this).data('gallery-category') !== '') {
      galleryCategories.push($(this).data('gallery-category'));
    }
  });

  galleryCategories.sort();

  $.each(galleryCategories, function (index, val) {
    $('#gallery-categories').append(new Option(val, val));
  });

  $('#gallery-categories').change(function () {
    var selected = $(this).find(":selected").val();

    $('.gallery__container').each(function () {

      if ($(this).data('gallery-category') === selected || selected === 'default') {
        $(this).removeClass('category-hidden');
        $(this).parent('.gallery__column--cover').removeClass('category-hidden');
      } else {
        $(this).addClass('category-hidden');
        $(this).parent('.gallery__column--cover').addClass('category-hidden');
      }
    });
  });

  // gallery Load More button
  var overflow = $('.gallery__column--overflow');
  if ($(overflow).children().length == 0) {
    $('.gallery__more').attr('disabled', true);
    $('.gallery__more').css('display', 'none');
  }

  $('.gallery__more').click(function () {
    $(overflow).addClass('show');
    $(this).attr('disabled', true);
    $(this).css('display', 'none');
  });
})(jQuery);